<script>
    import { onMount } from "svelte";
    import { SPRITES, TYPE_SPRITE_MAP } from "../../constants/sprites";
    import ComponentTiled from "./ComponentTiled.svelte";
    import {
      SetupStore,
      IsTurn,
      PlayerId,
      GameStateStore,
      MerchantTokenPosition,
      MerchantClicked
    } from "../stores/gameStore";
    import MerchantToken from "./MerchantToken.svelte";

    export let scale, left, top;
    
    let activeOutline = true;
    $: gameStateStore = $GameStateStore;
    $: merchantClicked = $MerchantClicked;
    $: {
        activeOutline = true;
        if ($GameStateStore?.possibleactions?.includes("getPotion") === false) {
            activeOutline = false;
          }
        if (merchantClicked === true) {
            activeOutline = true;
          break $;
        }
        if ($GameStateStore?.possibleactions?.includes("getPotion") === false) {
          activeOutline = false;
          break $;
        }
        if ($GameStateStore?.active_player != $PlayerId) {
          activeOutline = false;
          break $;
        }
      }

    $: merchantTokenPosition = $MerchantTokenPosition;

    const _id = Math.round(Math.random() * 10000).toString();
    const textPotionPile = _('Potion Pile');
    const textClickHere = _('Click here to receive potions');

    onMount(() => {
      window.GAME.addTooltipHtml(
        _id,
        `<div style="display:flex; flex-direction:column; max-width: 350px; word-wrap: break-word;">
          <div style="width:100%;display:flex;justify-content:space-between;align-items:center; gap:2rem;">
            <div class="headline">
              ${textPotionPile}
                </div>
            </div>
              <hr style="width:100%;"/>
              ${textClickHere}
                </div>
          </div>`
      );
    });
</script>  

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-no-static-element-interactions -->
<div class="pile"
  style:position="absolute"
  style:left="{left}px"
  style:top="{top}px"
  id={_id}
  class:active={activeOutline}
  on:click={merchantClicked
    ? (e) => {
        e.preventDefault();
        e.stopPropagation();
        window.GAME.bgaPerformAction("merchantToken", { cardId: "potion" });
        MerchantClicked.set(false);
        window.GAME.updatePageTitle();
      }
        
    : (e) => {
        e.preventDefault();
        e.stopPropagation();
        window.GAME.bgaPerformAction("getPotion", { playerId: $PlayerId });}
  }
>
    {#if merchantTokenPosition === "potion"}
        <MerchantToken
        scale= {scale}
        left= {scale}
        top= {42* scale}
        />
    {/if}

  <ComponentTiled
    width={SPRITES["ITEMS_FRONT"].width * scale * 0.5}
    sprite={SPRITES["POTION"]}
    borderRadius={15}
    offset={$SetupStore.data.cards.facedown.offset}
    className="shadow-sm"
  />

</div>

  

<style>
  .pile {
    position: absolute;
    filter: drop-shadow(0px 0px 3px #0000006b);
  }

  .active {
    cursor: pointer;
    outline: rgb(214, 149, 245) solid 2px;
    outline-offset: 2px;
    border-radius: 5px;
  }

  .active:hover {
    filter: brightness(1.2);
  }
</style>